import Vue from 'vue'
import axios from 'axios'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  isLoading: {},
  isMatchAthletesPerformanceLoading: false,
  all: {},
}

// getters
export const getters = {
  getMatchAthletesPerformance: ({ all }) => (matchId) => all[matchId] || [],
  getMatchAthletesPerformanceByMatchId: ({ all }) => (matchId) => all[matchId] || [],
  getIsMatchPerformanceLoading: ({ isLoading }) => (matchId) => isLoading[matchId] || false,
}
// mutations
export const mutations = {
  fetchMatchAthletesPerformanceStarted(state, { matchId }) {
    state.isMatchAthletesPerformanceLoading = true
    Vue.set(state.isLoading, matchId, true)
  },
  fetchMatchAthletesPerformanceSuccess(state, { matchId, athletesPerformance }) {
    Vue.set(state.all, matchId, athletesPerformance.map(({ athlete, ...rest }) => ({
      ...rest,
      athlete: processAthlete(athlete),
    })))
    state.isMatchAthletesPerformanceLoading = false
    Vue.set(state.isLoading, matchId, false)
  },
  fetchMatchAthletesPerformanceFailed(state, { matchId }) {
    state.isMatchAthletesPerformanceLoading = false
    Vue.set(state.isLoading, matchId, false)
  },
}
// actions
export const actions = {
  async fetchMatchAthletesPerformance({ commit, state: { all } }, { matchId }) {
    if (typeof all[matchId] !== 'undefined') {
      return all[matchId]
    }
    let athletesPerformance = null
    try {
      commit('fetchMatchAthletesPerformanceStarted', { matchId })
      athletesPerformance = await axios.get(`match/${matchId}/athletesPerformance`)
      commit('fetchMatchAthletesPerformanceSuccess', {
        matchId,
        athletesPerformance,
      })
    } catch (e) {
      commit('fetchMatchAthletesPerformanceFailed', { matchId })
    }
    return athletesPerformance
  },
}
